import { Translate } from 'next-translate';

import { SupplierOrganization } from 'types';

import { uniqById } from './uniqById';

export interface IncumbentOption {
  label: string;
  value: string;
}

export const getIncumbentOptions = (t: Translate, supplierOrgs?: SupplierOrganization[]): IncumbentOption[] => {
  const defaultOption: IncumbentOption = { label: t('general.none'), value: '' };

  if (!supplierOrgs?.length) return [defaultOption];
  const nonNullSupplierOrgs = supplierOrgs.filter(org => !!org);
  const uniqueOrgs = uniqById(nonNullSupplierOrgs);

  return [
    defaultOption,
    ...uniqueOrgs.map((org: SupplierOrganization) => ({
      label: org.name,
      value: String(org.id),
    })),
  ];
};
